import { useFormDialog } from './use-form-dialog'
import type { DialogOptions } from './use-dialog'
import type { FormItemProps } from '@el-plus/components/form'
import { createNameSpace } from '@el-plus/utils/bem'
import type { InputProps } from 'element-plus'
const bem = createNameSpace('confirm-dialog')
type Options = Partial<
  {
    title?: string
    width?: string
    dialogProps?: DialogOptions
  } & TextareaProps &
    TextareaFormItemProps
>
type TextareaProps = Pick<
  InputProps,
  'rows' | 'maxlength' | 'minlength' | 'showWordLimit' | 'placeholder'
>
type TextareaFormItemProps = Pick<FormItemProps, 'rules' | 'required'>
export const useConfirmDialog = (options: Options = {}) => {
  const {
    dialogProps = {},
    width = '50%',
    title,
    /** TextareaProps */
    rows = 5,
    maxlength = 500,
    minlength,
    showWordLimit = true,
    /** TextareaFormItemProps */
    rules,
    required = true,
    placeholder,
  } = options
  const formItemList: FormItemProps[] = [
    {
      rules,
      prop: 'value',
      label: ' ',
      required,
      props: {
        placeholder,
        type: 'textarea',
        rows,
        maxlength,
        minlength,
        showWordLimit,
      },
    },
  ]
  return useFormDialog({
    title,
    width,
    formItemList,
    dialogProps: {
      ...dialogProps,
      class: bem.b(),
      destroyOnClose: true,
    },
  })
}
